import { Injectable, InjectionToken } from '@angular/core';

export const LTI_AUTH_SERVICE = new InjectionToken<LtiAuthService>('[User-Auth] LtiAuthService');

const LTI_REQUEST_ID = 'lti_request_id';

// The pending deep-link request id, in session storage so that it survives a reload but stays with its
// tab: a launch in another tab clears that tab's own, not one a deep-link here is still waiting on.
@Injectable({ providedIn: 'root' })
export class LtiAuthService {
  saveLtiRequestId(requestId: string): void {
    sessionStorage.setItem(LTI_REQUEST_ID, requestId);
  }

  getLtiRequestId(): string {
    return sessionStorage.getItem(LTI_REQUEST_ID);
  }

  removeLtiRequestId(): void {
    sessionStorage.removeItem(LTI_REQUEST_ID);
  }
}
